module.exports = __webpack_public_path__ + "assets/img/16.46e44fd1.gif";